import { ref } from "vue";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import usePublicStore from "@/store/public";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import useStoreCotizaciones from "../store/cotizaciones";

const useCotizacion = () => {
  const { formAprobar } = storeToRefs(usePublicStore());
  const { stateCotizacionEditable } = storeToRefs(useStoreCotizaciones());
  const clientes = ref([]);
  const enganches = ref([]);
  const residuales = ref([]);
  const arrendamientos = ref([]);

  const cliente = ref("");
  const enganche = ref("");
  const residual = ref("");
  const arrendamiento = ref("");
  const importe = ref("");
  const rentas = ref("");
  const seguro = ref("");
  const linea = ref("");
  const moneda = ref("");
  const descripcion = ref("");
  const btnCargando = ref(false);
  const btnCloseModal = ref("");

  const consultandoInfoCotizaciones = ref(true);
  const cotizacionInfo = ref([]);
  const cotizacionTotales = ref([]);

  const fetchFormInfoCotizacion = async () => {
    try {
      const response = await appApi().get("cotizaciones");
      clientes.value = response.data.clientes;
      enganches.value = response.data.enganches;
      arrendamientos.value = response.data.arrendamientos;
      residuales.value = response.data.residuales;
    } catch (e) {
      console.error(e);
      exceptionRequestMsg(e);
    }
  };

  const fectchInfoCotizacionByToken = async (token) => {
    try {
      const response = await appApi().get(`public/cotizaciones/${token}/show`);
      cotizacionInfo.value = response.data.cotizacion;
      cotizacionTotales.value = response.data.cotizacion_totales;
      consultandoInfoCotizaciones.value = false;
    } catch (e) {
      exceptionRequestMsg(e);
    }
  };

  const approve_decline = async (token) => {
    const form = document.getElementById("formAcciones");
    const formData = new FormData(form);
    formData.append("approved", formAprobar.value);
    btnCargando.value = true;
    try {
      const response = await appApi().post(
        `public/cotizaciones/${token}/approve_decline`,
        formData
      );
      console.log(response);
      const { status, message, cotizacion, cotizacion_totales } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      cotizacionInfo.value = cotizacion;
      cotizacionTotales.value = cotizacion_totales;
      btnCargando.value = false;
      btnCloseModal.value.click();

      showToast(
        `La cotización #${cotizacion.id} se ha modificado exitosamente`,
        "success"
      );

      if (useRoute()?.query?.redirect != "false") {
        await setTimeout(() => {
          location.href =
            "https://ventusleasing.mx/pre-aprueba-tu-linea-paso-1-crea-tu-cuenta-o-inicia-sesion/";
        }, 3000);
      }
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      btnCargando.value = false;
    }
  };

  const modificando = ref(false);

  const modificarTotales = async (token) => {
    console.log(token);
    modificando.value = true;
    console.log(stateCotizacionEditable.value);
    try {
        const res = await appApi().put(`cotizaciones/${token}/modificarTotales`, {
          totales: stateCotizacionEditable.value
        })
    } catch (error) {
      console.error(error);
      exceptionRequestMsg(error);
    } finally {
      modificando.value = false;
    }
  };

  return {
    // Arreglos
    arrendamientos,
    clientes,
    cotizacionInfo,
    cotizacionTotales,
    enganches,
    residuales,

    // v-Models
    arrendamiento,
    btnCargando,
    btnCloseModal,
    cliente,
    consultandoInfoCotizaciones,
    descripcion,
    enganche,
    importe,
    linea,
    moneda,
    rentas,
    residual,
    seguro,

    // General
    modificando,

    // Funciones
    approve_decline,
    fectchInfoCotizacionByToken,
    fetchFormInfoCotizacion,
    modificarTotales,
  };
};

export default useCotizacion;
